<template>
  <!-- 商品管理页面根容器 -->
  <div>
    <!-- 页面标题 -->
    <h3 style="margin-bottom:20px">商品管理</h3>

    <!--
      搜索与新增按钮行
      响应式布局，适配手机、电脑
    -->
    <el-row :gutter="10" style="margin-bottom:15px">
      <!-- 搜索商品输入框 -->
      <el-col :xs="16" :sm="16" :md="6">
        <el-input
          v-model="searchKey"
          placeholder="搜索商品名称"
        />
      </el-col>

      <!-- 新增商品按钮 -->
      <el-col :xs="8" :sm="8" :md="4">
        <el-button
          type="primary"
          @click="openAddDialog"
        >
          新增商品
        </el-button>
      </el-col>
    </el-row>

    <!--
      商品数据表格
      :data 绑定表格数据
      border 显示边框
      @row-dblclick 双击查看详情
    -->
    <el-table
      :data="showList"
      border
      @row-dblclick="showGoodsDetail"
    >
      <!-- 商品ID列 -->
      <el-table-column prop="id" label="商品ID" />

      <!-- 商品名称列 -->
      <el-table-column prop="name" label="商品名称" />

      <!-- 商品价格列 -->
      <el-table-column prop="price" label="价格" />

      <!-- 商品库存列 -->
      <el-table-column prop="stock" label="库存" />

      <!-- 操作列：删除按钮 -->
      <el-table-column label="操作">
        <template #default="scope">
          <el-button
            size="mini"
            type="danger"
            @click="delGoods(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--
      新增商品弹窗
      点击新增按钮时打开
    -->
    <el-dialog
      title="新增商品"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <!-- 新增商品表单 -->
      <el-form :model="form" label-width="80px">
        <el-form-item label="商品名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="商品价格">
          <el-input v-model.number="form.price"></el-input>
        </el-form-item>

        <el-form-item label="商品库存">
          <el-input v-model.number="form.stock"></el-input>
        </el-form-item>
      </el-form>

      <!-- 弹窗底部按钮 -->
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>

    <!--
      商品详情弹窗
      双击表格行打开
    -->
    <el-dialog
      title="商品详情"
      :visible.sync="detailVisible"
      :close-on-click-modal="false"
    >
      <!-- 详情表单，禁用状态，仅用于查看 -->
      <el-form :model="currentGoods" label-width="80px" disabled>
        <el-form-item label="商品ID">
          <span>{{ currentGoods.id }}</span>
        </el-form-item>

        <el-form-item label="商品名称">
          <span>{{ currentGoods.name }}</span>
        </el-form-item>

        <el-form-item label="价格">
          <span>¥ {{ currentGoods.price }}</span>
        </el-form-item>

        <el-form-item label="库存">
          <span>{{ currentGoods.stock }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  // 页面数据定义
  data() {
    return {
      searchKey: "",        // 搜索关键词
      goodsList: [],        // 商品列表原始数据
      dialogVisible: false, // 新增弹窗显示控制
      detailVisible: false, // 详情弹窗显示控制
      currentGoods: {},      // 当前查看的商品对象
      form: {                // 新增商品表单
        name: "",
        price: 0,
        stock: 0
      }
    };
  },

  // 计算属性：根据搜索关键词过滤商品列表
  computed: {
    showList() {
      // 无搜索内容，显示全部商品
      if (!this.searchKey) {
        return this.goodsList;
      }
      // 有搜索内容，模糊匹配商品名称
      return this.goodsList.filter((item) =>
        item.name.includes(this.searchKey)
      );
    }
  },

  // 页面挂载完成后自动加载商品列表
  async mounted() {
    const { data } = await this.$axios.get("/api/goods/list");
    this.goodsList = data.data;
  },

  // 页面方法集合
  methods: {
    // 打开新增商品弹窗，并重置表单
    openAddDialog() {
      this.form = { name: "", price: 0, stock: 0 };
      this.dialogVisible = true;
    },

    // 提交新增商品
    submitAdd() {
      // 前端校验：商品名称不能为空
      if (!this.form.name) {
        this.$message.warning("请填写商品名称");
        return;
      }

      // 将新商品添加到列表
      this.goodsList.push({
        id: Date.now(),        // 使用时间戳作为唯一ID
        name: this.form.name,
        price: this.form.price,
        stock: this.form.stock
      });

      // 关闭弹窗并提示成功
      this.dialogVisible = false;
      this.$message.success("新增成功");
    },

    // 删除商品
    delGoods(row) {
      this.$confirm("是否删除该商品？", "提示", {
        closeOnClickModal: false
      }).then(() => {
        // 过滤掉当前删除的商品
        this.goodsList = this.goodsList.filter((x) => x.id !== row.id);
        this.$message.success("删除成功");
      }).catch(() => {
        // 取消删除，不执行操作
      });
    },

    // 显示商品详情弹窗
    showGoodsDetail(row) {
      // 将当前行数据赋值给详情对象
      this.currentGoods = row;
      this.detailVisible = true;
    }
  }
};
</script>